import { CrmV3SignUpRedirect } from '@/components/auth/crm-v3-sign-up-redirect';
import { CustomSignUp } from '@/components/auth/custom-sign-up';
import { PartnerOtpSignIn } from '@/components/auth/partner-otp-sign-in';
import { resolveSatellite } from '@/config/clerk-satellite';
import { crmV3SignUpUrlFor } from '@/hooks/use-crm-v3-redirect';

/**
 * Sign-up entry point.
 *
 *  - Tagada's own host (app.tagada.io, app.tagada.dev) → the CRM V3 sign-up.
 *  - Other primary hosts (white-label deploys, local dev) → <CustomSignUp />
 *    (Clerk signUp.create + Google).
 *  - Partner whitelabel satellite → <PartnerOtpSignIn mode="sign-up" />.
 *    Clerk blocks signUp.create on satellites and we must not show a
 *    Google button (it would leak the "Tagada" OAuth app name), so the
 *    partner sign-up is the same self-owned OTP exchange as sign-in —
 *    the backend's lookup-or-create makes it an implicit sign-up.
 */
export default function SignUpPage() {
  const satellite = resolveSatellite();

  if (satellite) {
    return <PartnerOtpSignIn mode="sign-up" />;
  }

  const v3SignUpUrl = crmV3SignUpUrlFor(window.location.hostname);
  if (v3SignUpUrl) {
    return <CrmV3SignUpRedirect url={v3SignUpUrl} />;
  }

  return <CustomSignUp />;
}
